import { Theme } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

interface IStylesProps {
  backgroundColor: string;
  strokeColor: string;
}

export default makeStyles<Theme, IStylesProps>((theme: MuiTheme) => {
  const { primary, text, common } = theme.palette;

  return {
    card: {
      position: "relative",
      minHeight: 60,
      height: 60,
      width: 60,
      minWidth: 60,
      marginRight: 10,
      marginTop: 10,
      borderRadius: 3,
      cursor: "pointer",
      boxShadow: "0 1px 7px 0 rgb(0, 0, 0, 0.08)",
      backgroundColor: common.white,
      "&.scheduled": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderWidth: 1,
        borderStyle: "solid",
        overflow: "visible",
        boxShadow: "none",
        color: ({ backgroundColor }) =>
          backgroundColor ? `#${backgroundColor}` : text.primary,
        backgroundColor: ({ backgroundColor }) =>
          backgroundColor ? `#${backgroundColor}` : common.white,
        borderColor: ({ strokeColor }) =>
          strokeColor ? `#${strokeColor}` : common.black
      }
    },
    cardDisabled: {
      pointerEvents: "none",
      border: "1px solid #d8d8d8",
      backgroundColor: "#eeeeee",
      boxShadow: "none",
      "& $dayName": {
        color: "#d8d8d8"
      },
      "& $date": {
        color: "#d8d8d8"
      }
    },
    cardHeader: {
      borderRadius: "2px 2px 0 0",
      backgroundColor: "rgba(216, 216, 216, 0.25)",
      height: 9,
      "&.scheduled": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& > div": {
          overflow: "hidden"
        },
        borderRadius: "3px 3px 0 0",
        padding: 0,
        height: 16,
        fontSize: 10,
        marginBottom: "0",
        whiteSpace: "nowrap",
        textAlign: "center",
        paddingLeft: 0,
        paddingRight: 0,
        backgroundColor: ({ strokeColor }) =>
          strokeColor ? `#${strokeColor}` : primary.main,
        color: ({ backgroundColor }) =>
          backgroundColor ? `#${backgroundColor}` : common.white
      }
    },
    squared: {
      color: text.primary,
      borderRadius: 2,
      border: "1px solid",
      "&.scheduled": {
        color: primary.light
      }
    },
    cardContent: {
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      justifyContent: "center",
      padding: 0,
      maxHeight: 49,
      position: "relative",
      "&.scheduled": {
        maxHeight: 42,
        position: "initial"
      }
    },
    dateWrapper: {
      position: "relative",
      padding: 0
    },
    date: {
      lineHeight: "normal",
      width: 24,
      height: 22,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 16,
      fontWeight: "bold",
      textAlign: "center",
      "&.scheduled": {
        position: "relative",
        top: -5,
        color: ({ strokeColor }) =>
          strokeColor ? `#${strokeColor}` : text.primary
      }
    },
    loader: {
      position: "absolute",
      zIndex: 1,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      padding: 0,
      borderRadius: 3,
      background: "rgba(255, 255, 255, 0.85)"
    },
    dayName: {
      position: "absolute",
      top: -24,
      lineHeight: 1,
      color: text.secondary,
      fontSize: 10,
      width: "100%",
      textAlign: "center",
      "&.scheduled": {
        padding: 0,
        color: ({ strokeColor }) =>
          strokeColor ? `#${strokeColor}` : text.primary
      }
    },
    cardActions: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 0,
      height: 16,
      maxHeight: 16,
      bottom: 0,
      left: 0,
      right: 0,
      overflow: "hidden"
    },
    moreHorizIcon: {
      fontSize: 18,
      color: ({ strokeColor }) =>
        strokeColor ? `#${strokeColor}` : text.primary
    },
    commentIcon: {
      fontSize: 9,
      color: common.black,
      opacity: 0.4,
      position: "absolute",
      right: 2,
      bottom: 1
    }
  };
});
